var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-event-ticket-list-empty text-center"},[_c('h5',{staticClass:"mt-9 mx-6 mx-md-10"},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")]),_c('p',{staticClass:"mt-4 mx-6 mx-md-10"},[_vm._v(" "+_vm._s(_vm.$t('message'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }